<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-bottom-16">
    <div
      v-if="message.primaryImageUrl"
      class="cf-image-container cf-image-container--bleed"
    >
      <img
        v-if="message.primaryImageUrl"
        class="cf-image"
        :src="message.primaryImageUrl"
        :alt="`${message.title} image`"
        data-test-id="message-image"
        onerror="this.src='/images/image-not-found.png';"
      >
    </div>

    <h2
      class="cf-title cf-title--2"
      data-test-id="message-title"
    >
      {{ message.title }}
    </h2>

    <p
      data-test-id="message-body"
      class="cf-subtitle cf-subtitle--2"
    >
      {{ message.bodyContent }}
    </p>

    <button
      v-if="message.ctaContent"
      class="cf-button cf-button--primary cf-button--lg cf-button--fill"
      type="button"
      data-test-id="message-cta"
      @click="ctaHandler(message.ctaLink)"
    >
      {{ message.ctaContent }}
    </button>
  </div>
</template>


<script>
  export default {
    name: 'InAppMessage',

    props: {
      message: {
        type: Object,
        required: true
      }
    },

    created() {
      if (!this.message.alwaysShow) this.$store.dispatch('merchant/markMessageSeen', this.message);
    },

    methods: {
      formatRoute(link) {
        const url = new URL(link);

        const searchParams = new URLSearchParams(url.search);

        const query = {};

        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of searchParams.entries()) {
          query[key] = value;
        }

        return {
          path: url.pathname,
          query
        };
      },


      ctaHandler(ctaLink) {
        if (ctaLink) {
          const route = this.formatRoute(ctaLink);

          this.$router.push(route);
        }

        this.$closeModal('inAppMessage');
      }
    }
  };
</script>
